export const mbrMembraneProducts = {
  'mbr-curtain-membrane-module': {
    title: 'MBR Curtain Membrane Module',
    category: 'MBR Curtain Membrane',
    description: 'Embedded hollow fiber curtain membrane with modified PVDF material for advanced MBR processes.',
    longDescription: 'The embedded hollow fiber curtain membrane uses modified PVDF material with a unique braided tube structure that has high strength and effectively eliminates the phenomenon of broken filaments. The unique coating production process makes the membrane tightly combined with the inner braided tube, effectively avoiding membrane peeling phenomenon, and the recul resistance is greatly enhanced. The membrane features high water flux, high separation accuracy, strong chemical resistance, and long service life.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/7ec3b130e1e35a5e82093548331e546f.jpg',
    features: [
      'High water flux by modifying PVDF material - hydrophilicity improved, porosity increased by more than 30%',
      'High separation accuracy with uniform and dense membrane pores (0.03-0.1 μm separation aperture)',
      'Embedded braided tube structure has high strength and effectively eliminates broken filaments',
      'Unique coating production process prevents membrane peeling phenomenon',
      'Strong chemical resistance - can be more thoroughly chemically cleaned for better membrane flux recovery',
      'Long service life with enhanced recul resistance and longer service life'
    ],
    specifications: {
      'Membrane Material': 'Modified Polyvinylidene fluoride (PVDF)',
      'Membrane Aperture': '0.03-0.1 μm',
      'Hollow Fiber Structure': 'Embedded braided tube structure',
      'Hydrophilicity': 'Improved through PVDF modification',
      'Porosity Increase': '>30% compared to standard PVDF',
      'Filtration Method': 'Outside-in filtration',
      'Chemical Resistance': 'Enhanced for thorough chemical cleaning',
      'Membrane Flux Recovery': 'High recovery rate after cleaning',
      'Service Life': 'Extended due to anti-peeling design',
      'Operating Temperature': '5-45°C',
      'pH Range': '2-12 (cleaning: 1-13)',
      'Max Operating Pressure': '0.05 MPa',
      'Recommended Operating Pressure': '0.01-0.03 MPa'
    },
    processFlow: {
      description: 'MBR process flow chart showing the complete treatment stages from raw water to clean water tank',
      stages: [
        'Raw water input through regulation pool',
        'Biochemical treatment in biochemical pool',
        'Membrane filtration in membrane pool',
        'Production pump and backwash pump operation',
        'Clean water collection in clean water tank',
        'Sodium hypochlorite and citric acid dosing for cleaning'
      ],
      components: [
        'Regulation pool',
        'Biochemical pool', 
        'Membrane pool',
        'Production pump',
        'Backwash pump',
        'Clean water tank',
        'Sodium hypochlorite dosing',
        'Citric acid dosing'
      ]
    },
    applications: [
      'Municipal wastewater treatment',
      'Industrial wastewater treatment and reuse',
      'Membrane bioreactor (MBR) systems',
      'Advanced biological treatment processes',
      'Water reclamation and recycling',
      'High-strength wastewater treatment',
      'Pharmaceutical and chemical industry wastewater',
      'Food and beverage industry wastewater treatment'
    ],
    testConditions: {
      'Test Temperature': '25°C',
      'Test Pressure': '0.02 MPa',
      'Feed Water': 'Municipal wastewater',
      'MLSS Concentration': '8000-12000 mg/L',
      'Designed Water Flux': '15-25 L/m²·h',
      'COD Removal': '>95%',
      'BOD Removal': '>98%',
      'SS Removal': '>99%',
      'Turbidity': '<1 NTU'
    },
    productFeatures: [
      {
        title: 'High Water Flux',
        description: 'By modifying PVDF, the hydrophilicity of the membrane is greatly improved, the porosity of the membrane is more than 70%, and the flux of water membrane product is increased by more than 30%.'
      },
      {
        title: 'High Separation Accuracy', 
        description: 'The membrane pores are uniform and dense, and it can be controlled within 0.03-0.1 μm separation aperture to ensure the filtration precision.'
      },
      {
        title: 'Long Service Life',
        description: 'The unique embedded braided tube structure has high strength, and effectively eliminates the phenomenon of broken filaments, the unique coating production process makes the membrane tightly combined with the inner braided tube, effectively avoid membrane peeling phenomenon, recul resistance is greatly enhanced.'
      },
      {
        title: 'Strong Chemical Resistance',
        description: 'It can be more thoroughly chemically cleaned to better solve the problem of membrane fouling, high recovery rate of membrane flux and longer service life.'
      }
    ],
    dimensions: [
      {
        model: 'MBR-CM-Standard',
        length: 'Customizable',
        width: 'Customizable', 
        membraneArea: 'Varies by configuration',
        fiberDiameter: '0.8-1.2mm',
        packingDensity: 'High density configuration'
      }
    ]
  }
};

export const mbrMembraneProductsList = [
  {
    id: 'mbr-curtain-membrane-module',
    name: 'MBR Curtain Membrane Module',
    category: 'MBR Curtain Membrane',
    description: 'Embedded hollow fiber curtain membrane with modified PVDF material featuring unique braided tube structure',
    features: ['High water flux with modified PVDF', 'Unique braided tube structure', 'Strong chemical resistance', 'Long service life'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/7ec3b130e1e35a5e82093548331e546f.jpg'
  }
];